import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class EmpresaGloboService extends CRUDService{
    constructor() {
        super("empresaglobo");
    }

    listByPrefixoNome(nome) {
        return http.get(`/empresaglobo/prefixo/${encodeURIComponent(nome)}`);
    }

    list(){
        return http.get("/empresaglobo");
    }
}
